import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';
import { InstructorStatus } from '../data/instructors';

interface StatusIndicatorProps {
  status: InstructorStatus;
  label: string;
}

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

const Dot = styled.span<{ color: string }>(({ color }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: color,
}));

const Label = styled.span<{ color: string }>(({ color }) => ({
  fontFamily: t.font,
  fontSize: 13,
  fontWeight: 500,
  color,
}));

/**
 * Primitivo: punto + etiqueta que comunica si el instructor está activo.
 */
const StatusIndicator = ({ status, label }: StatusIndicatorProps) => {
  const active = status === 'active';
  return (
    <Row>
      <Dot color={active ? t.color.statusActive : t.color.statusInactive} />
      <Label color={active ? t.color.statusActiveText : t.color.statusInactiveText}>{label}</Label>
    </Row>
  );
};

export default StatusIndicator;
